import { changeDisplayLocation } from './changeDisplayLocation';
import { hide } from './hide';
import { hideWithoutChangingDisplayLocation } from './hideWithoutChangingDisplayLocation';
import { show } from './show';

export const alertActions = {
  changeDisplayLocation,
  hide,
  hideWithoutChangingDisplayLocation,
  show,
};
